import Vue from 'vue'

import ChartLine from './ChartLine.vue'

Vue.component('chart-line', ChartLine)
